import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const ViewModal = (props) => {

  const { viewdata } = props;

  const prepareHtml = (description = "") => ({
    __html: description,
  });

  const modalStyle = {
    maxHeight: '70vh',
    overflowX: 'hidden',
    overflowY: 'scroll'
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered className="calendar-modal"
    >
      <Modal.Header closeButton>
        {viewdata.title}
      </Modal.Header>

      <Modal.Body className="newsletter-html" style={modalStyle}>
        {viewdata.type === 'newsletter' ? (
          <div
            dangerouslySetInnerHTML={prepareHtml(
              viewdata.item
            )}
          ></div>
        ) : (
          <div style={{ margin: "-13px", marginBottom: "-17px" }}>
            <iframe width="100%" height="500" src={"https://www.youtube.com/embed/" + viewdata?.item + "?autoplay=1&start=0"} title={viewdata.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

ViewModal.propTypes = {
  viewdata: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    item: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }).isRequired
};

export default ViewModal;
